import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import { FaStar, FaUser } from "react-icons/fa";
import { Autoplay } from "swiper/modules";

const Testimonial = () => {
  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="subheading-txt">Property Reviews</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 col-12">
              <div className="customers-say-div">
                <div className="star-icon-div">
                  <FaStar className="star-icon" />
                  <FaStar className="star-icon" />
                  <FaStar className="star-icon" />
                  <FaStar className="star-icon" />
                  <FaStar className="star-icon" />
                </div>
                <div>
                  <h4 className="customer-say-txt">
                    What Our Customers <br /> are saying
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-md-8 col-12">
              <Swiper
                className="region-button"
                spaceBetween={10} // Space between slides
                slidesPerView={1} // Force 8 slides to fit within the first view
                freeMode={true} // Enable free scrolling
                modules={[Autoplay]} // Pass the Autoplay module here
                autoplay={{
                  delay: 3000, // Delay between slides in milliseconds (e.g., 3 seconds)
                  disableOnInteraction: false, // Allow autoplay to continue even after user interaction
                }}
                style={{
                  padding: "10px 0px", // Padding around text
                }}
              >
                <SwiperSlide
                  className="property-review-slider"
                  style={{
                    padding: "20px", // Padding around text
                    backgroundColor: "#E7EDF8",
                    border: "none",
                    borderRadius: "15px", // Rounded corners
                  }}
                >
                  <div className="main-review-div">
                    <div className="review-content-div">
                      <p className="content-para">
                        I found my dream home on HomesDekho.com and couldn't be
                        happier! The process was smooth, and the platform made
                        it incredibly easy to browse credible listings. Their
                        service was top-notch from start to finish. Highly
                        recommended for anyone looking for a hassle-free
                        home-buying experience!
                      </p>
                    </div>
                    <div className="user-info-review-div">
                      <div className="review-user-icon-div">
                        <FaUser className="review-user-icon" />
                      </div>
                      <div className="review-user-info-div">
                        <p className="review-user-name-txt">Rohan Mehta</p>
                        <p className="review-user-post-txt">
                          Software Engineer
                        </p>
                        <div className="star-icon-user-div">
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide
                  className="property-review-slider"
                  style={{
                    padding: "20px", // Padding around text
                    backgroundColor: "#E7EDF8",
                    border: "none",
                    borderRadius: "15px", // Rounded corners
                  }}
                >
                  <div className="main-review-div">
                    <div className="review-content-div">
                      <p className="content-para">
                        HomesDekho.com helped me find the perfect flat within my
                        budget. Their listings are detailed, genuine, and very
                        easy to navigate. I'm beyond satisfied with the purchase
                        I made, it truly feels like home. This platform made my
                        dream come true!
                      </p>
                    </div>
                    <div className="user-info-review-div">
                      <div className="review-user-icon-div">
                        <FaUser className="review-user-icon" />
                      </div>
                      <div className="review-user-info-div">
                        <p className="review-user-name-txt">Priya Sharma</p>
                        <p className="review-user-post-txt">
                          Marketing Executive
                        </p>
                        <div className="star-icon-user-div">
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide
                  className="property-review-slider"
                  style={{
                    padding: "20px", // Padding around text
                    backgroundColor: "#E7EDF8",
                    border: "none",
                    borderRadius: "15px", // Rounded corners
                  }}
                >
                  <div className="main-review-div">
                    <div className="review-content-div">
                      <p className="content-para">
                        From browsing to buying, HomesDekho made everything so
                        effortless. Their team was responsive, and the property
                        options were excellent. I got a great deal and found the
                        ideal home for my family. Extremely happy with the
                        service and my purchase!
                      </p>
                    </div>
                    <div className="user-info-review-div">
                      <div className="review-user-icon-div">
                        <FaUser className="review-user-icon" />
                      </div>
                      <div className="review-user-info-div">
                        <p className="review-user-name-txt">Amit Verma</p>
                        <p className="review-user-post-txt">Project Manager</p>
                        <div className="star-icon-user-div">
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide
                  className="property-review-slider"
                  style={{
                    padding: "20px", // Padding around text
                    backgroundColor: "#E7EDF8",
                    border: "none",
                    borderRadius: "15px", // Rounded corners
                  }}
                >
                  <div className="main-review-div">
                    <div className="review-content-div">
                      <p className="content-para">
                        A friend recommended HomesDekho and I'm so glad I
                        listened! It's one of the most credible platforms out
                        there with verified listings and real-time support. I
                        found my dream property in just a few days, worth every
                        second I spent searching.
                      </p>
                    </div>
                    <div className="user-info-review-div">
                      <div className="review-user-icon-div">
                        <FaUser className="review-user-icon" />
                      </div>
                      <div className="review-user-info-div">
                        <p className="review-user-name-txt">Sneha Iyer</p>
                        <p className="review-user-post-txt">HR Specialist</p>
                        <div className="star-icon-user-div">
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide
                  className="property-review-slider"
                  style={{
                    padding: "20px", // Padding around text
                    backgroundColor: "#E7EDF8",
                    border: "none",
                    borderRadius: "15px", // Rounded corners
                  }}
                >
                  <div className="main-review-div">
                    <div className="review-content-div">
                      <p className="content-para">
                        What a fantastic experience! HomesDekho.com made house
                        hunting so simple and transparent. Their team guided me
                        every step of the way and helped me close a great deal.
                        I now live in a place I truly love, thank you!
                      </p>
                    </div>
                    <div className="user-info-review-div">
                      <div className="review-user-icon-div">
                        <FaUser className="review-user-icon" />
                      </div>
                      <div className="review-user-info-div">
                        <p className="review-user-name-txt">Kunal Kapoor</p>
                        <p className="review-user-post-txt">Entrepreneur</p>
                        <div className="star-icon-user-div">
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide
                  className="property-review-slider"
                  style={{
                    padding: "20px", // Padding around text
                    backgroundColor: "#E7EDF8",
                    border: "none",
                    borderRadius: "15px", // Rounded corners
                  }}
                >
                  <div className="main-review-div">
                    <div className="review-content-div">
                      <p className="content-para">
                        I can't believe how easy it was to find my new home on
                        HomesDekho.com. The interface is user-friendly, and the
                        listings are all reliable. Their support team made the
                        whole buying process stress-free. Best decision I've
                        ever made!
                      </p>
                    </div>
                    <div className="user-info-review-div">
                      <div className="review-user-icon-div">
                        <FaUser className="review-user-icon" />
                      </div>
                      <div className="review-user-info-div">
                        <p className="review-user-name-txt">Neha Joshi</p>
                        <p className="review-user-post-txt">
                          Interior Designer
                        </p>
                        <div className="star-icon-user-div">
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide
                  className="property-review-slider"
                  style={{
                    padding: "20px", // Padding around text
                    backgroundColor: "#E7EDF8",
                    border: "none",
                    borderRadius: "15px", // Rounded corners
                  }}
                >
                  <div className="main-review-div">
                    <div className="review-content-div">
                      <p className="content-para">
                        HomesDekho turned a stressful task into a delightful
                        experience. I found multiple great options, shortlisted
                        easily, and finalized a home that fit my needs
                        perfectly. Their credibility and service are amazing.
                        I'm happy with my new space!
                      </p>
                    </div>
                    <div className="user-info-review-div">
                      <div className="review-user-icon-div">
                        <FaUser className="review-user-icon" />
                      </div>
                      <div className="review-user-info-div">
                        <p className="review-user-name-txt">Rahul Deshmukh</p>
                        <p className="review-user-post-txt">
                          Chartered Accountant
                        </p>
                        <div className="star-icon-user-div">
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide
                  className="property-review-slider"
                  style={{
                    padding: "20px", // Padding around text
                    backgroundColor: "#E7EDF8",
                    border: "none",
                    borderRadius: "15px", // Rounded corners
                  }}
                >
                  <div className="main-review-div">
                    <div className="review-content-div">
                      <p className="content-para">
                        After weeks of searching, HomesDekho.com gave me exactly
                        what I was looking for, a perfect home at a fair price.
                        The platform is trustworthy. It's a must-visit site for
                        buyers!
                      </p>
                    </div>
                    <div className="user-info-review-div">
                      <div className="review-user-icon-div">
                        <FaUser className="review-user-icon" />
                      </div>
                      <div className="review-user-info-div">
                        <p className="review-user-name-txt">Divya Nair</p>
                        <p className="review-user-post-txt">Content Writer</p>
                        <div className="star-icon-user-div">
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide
                  className="property-review-slider"
                  style={{
                    padding: "20px", // Padding around text
                    backgroundColor: "#E7EDF8",
                    border: "none",
                    borderRadius: "15px", // Rounded corners
                  }}
                >
                  <div className="main-review-div">
                    <div className="review-content-div">
                      <p className="content-para">
                        Absolutely love my new home, all thanks to HomesDekho!
                        The platform made it incredibly easy to compare,
                        shortlist, and connect with sellers. Their support was
                        amazing and helped me lock in a fantastic deal quickly.
                      </p>
                    </div>
                    <div className="user-info-review-div">
                      <div className="review-user-icon-div">
                        <FaUser className="review-user-icon" />
                      </div>
                      <div className="review-user-info-div">
                        <p className="review-user-name-txt">Siddharth Rao</p>
                        <p className="review-user-post-txt">
                          Financial Analyst
                        </p>
                        <div className="star-icon-user-div">
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide
                  className="property-review-slider"
                  style={{
                    padding: "20px", // Padding around text
                    backgroundColor: "#E7EDF8",
                    border: "none",
                    borderRadius: "15px", // Rounded corners
                  }}
                >
                  <div className="main-review-div">
                    <div className="review-content-div">
                      <p className="content-para">
                        Buying a home was always a dream and HomesDekho helped
                        make it a reality! The listings are credible, the
                        service is efficient, and the process was seamless. I'm
                        now living in my dream home and couldn't be more
                        grateful.
                      </p>
                    </div>
                    <div className="user-info-review-div">
                      <div className="review-user-icon-div">
                        <FaUser className="review-user-icon" />
                      </div>
                      <div className="review-user-info-div">
                        <p className="review-user-name-txt">Ananya Singh</p>
                        <p className="review-user-post-txt">School Teacher</p>
                        <div className="star-icon-user-div">
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                          <FaStar className="star-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonial;
